import "../../../../assets/presentation/components/controls/text-input/text-input-label-CO8lVJSj.css";
/* empty css                 */
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/text-input/text-input-label.tsx
var TextInputLabel = ({ className, children, testId }) => /* @__PURE__ */ jsx("label", {
	className: classNames(className, "text-input-label"),
	"data-testid": testId,
	children
});
//#endregion
export { TextInputLabel };

//# sourceMappingURL=text-input-label2.js.map